import { render, staticRenderFns } from "./VContactsAutocomplete.vue?vue&type=template&id=44d4785a"
import script from "./VContactsAutocomplete.vue?vue&type=script&lang=js"
export * from "./VContactsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports